import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AlreadyAuthGuardTsGuard} from "./guard/already-auth-guard.ts.guard";
import {HomepageComponent} from "./modules/base/homepage/homepage.component";
import {TermsConditionComponent} from "./modules/base/terms-condition/terms-condition.component";
import {LoginComponent} from "./modules/base/acesso/login/login.component";
import {RegisterComponent} from "./modules/base/acesso/registro/register.component";
import {RecoverPasswordComponent} from "./modules/base/acesso/recover-password/recover-password.component";
import {
  AccountActivationComponent
} from "./modules/base/acesso/activation/account-activation/account-activation.component";
import {MainlayoutComponent} from "./shared/components/layout/mainlayout/mainlayout.component";
import {AcessolayoutComponent} from "./shared/components/layout/acessolayout/acessolayout.component";
import {AccessForbiddenComponent} from "./shared/components/access-forbidden/access-forbidden.component";
import {RegistroSuccessComponent} from "./modules/base/acesso/registro/registro-success/registro-success.component";

const routes: Routes = [

  {
    path: '', component: MainlayoutComponent, children: [
      {path: '', component: HomepageComponent},
      {path: 'faq', redirectTo: '', pathMatch: 'full'},
      {path: 'termos', component: TermsConditionComponent},
    ]
  },

  {path: 'proibido', component: AccessForbiddenComponent},
  {path: 'verificar-activacao', redirectTo: '/acesso/activar', pathMatch: 'full'},
  {path: 'registrar-sucesso', component: RegistroSuccessComponent},


  //access routing
  {
    path: 'acesso', component: AcessolayoutComponent, children: [
      {path: '', component: LoginComponent},
      {path: 'registrar', component: RegisterComponent},
      {path: 'recuperar', component: RecoverPasswordComponent},
      {path: 'nova-passe', redirectTo: 'recuperar', pathMatch: 'full'},
      {path: 'activar', component: AccountActivationComponent},
    ],
    canActivate: [AlreadyAuthGuardTsGuard],
    canActivateChild: [AlreadyAuthGuardTsGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
